"use client";

import { SiteHero, Ladder, SplitRow, FullBleedPhoto, FaqList, CtaBand, RelatedLinks } from "@/components/marketing/site-ui";
import { CommunityThreadMock } from "@/components/marketing/site-mocks";
import { useSiteContent } from "@/components/marketing/use-site-content";

export function CommunitiesClient() {
  const c = useSiteContent();
  const page = c.communitiesPage;

  return (
    <>
      <SiteHero
        eyebrow={page.eyebrow}
        title={page.title}
        lede={page.lede}
        primaryLabel={page.primary}
        note={page.note}
        aside={<CommunityThreadMock />}
      />

      <section className="border-y border-neutral-200 bg-white py-14 md:py-20">
        <div className="gs-page">
          <Ladder steps={page.ladder} />
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="gs-page">
          <SplitRow
            eyebrow={page.howEyebrow}
            title={page.howTitle}
            body={page.howBody}
            items={page.howItems}
            flip
            aside={
              /* A pull quote rather than a second mock. The community page's argument is
                 social, not visual, and a second screenshot here would say nothing new. */
              <figure className="rounded-[1.75rem] bg-[#090f39] p-8 text-white md:p-12">
                <blockquote className="text-balance text-2xl font-bold leading-[1.25] tracking-[-0.025em] md:text-[1.75rem]">
                  {page.pullQuote}
                </blockquote>
                <figcaption className="mt-6 text-[13.5px] leading-relaxed text-white/60">{page.pullQuoteMeta}</figcaption>
              </figure>
            }
          />
        </div>
      </section>

      <FullBleedPhoto
        src="/images/communities-roundtable-wide.webp"
        alt={page.photoAlt}
        eyebrow={page.photoEyebrow}
        title={page.photoTitle}
        body={page.photoBody}
      />

      <section className="py-16 md:py-20">
        <div className="gs-page">
          {/* The measure goes on an inner box: .gs-page centres, so a narrower max-width on it
              would recentre this section and move the page's left edge. */}
          <div className="max-w-4xl">
            <FaqList heading={c.common.faqHeading} items={page.faq} />
          </div>
        </div>
      </section>

      <RelatedLinks
        links={[
          { href: "/features/events", title: c.features.events.name, body: c.features.events.tagline },
          { href: "/features/reputation", title: c.features.reputation.name, body: c.features.reputation.tagline },
          { href: "/safety", title: c.company.safety, body: c.company.safetyTagline },
        ]}
      />

      <div className="pt-14 md:pt-20">
        <CtaBand />
      </div>
    </>
  );
}
